import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Previne ghost clicks durante transições de rota
 * Captura e descarta cliques que ocorrem imediatamente após navegação
 */
export const NavigationBlocker = () => {
  const location = useLocation();
  const isTransitioning = useRef(false);

  useEffect(() => {
    isTransitioning.current = true;

    const handleClick = (e: MouseEvent) => {
      if (isTransitioning.current) {
        e.stopPropagation();
        e.preventDefault();
      }
    };

    // Captura cliques na fase de capture (antes de chegar aos elementos)
    document.addEventListener('click', handleClick, true);

    // Libera após o React ter tempo de montar o novo componente
    const timer = requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        isTransitioning.current = false;
      });
    });

    return () => {
      document.removeEventListener('click', handleClick, true);
      cancelAnimationFrame(timer);
    };
  }, [location.pathname]);

  return null;
};
